import React, { useEffect } from 'react';
import '../css/edit-event.css'
// import { functionContext } from '../app'

const EditEvent = ({ setcurrentYear, currentYear, currentMonth, setisEditing, isEditing, setnameToEdit, setdateToEdit, setidToEdit, nameToEdit, dateToEdit, idToEdit, changeSelectedMonth, updateevent, deleteevent }) => {

  // const { } = useContext(functionContext);

  function handleClick(e) {
    if (nameToEdit === 'Edit user' || nameToEdit === "" || nameToEdit === " ") {
      alert("You cannot send an empty form") 
    } else if (dateToEdit === "" || dateToEdit === "mm/dd/yyyy" || dateToEdit === " ") {
      alert("You cannot send an empty form") 
    } else {

    updateevent(idToEdit, nameToEdit, dateToEdit)
    // afterEffect(e)
    clearInputs()
      // console.log(e.value)

      // setTimeout(() => afterEffect(e), 500)
      afterEffect(e)
      
    
    }

    setisEditing(false)
    //   console.log(changedMonth)
    // changeSelectedMonth(changedMonth)
  }

  function afterEffect(e) {
    // console.log(e.value.substr(5, 2))



    let changedMonth = (e.value.substr(5, 2));
    if (changedMonth < 10) {
      let lowMonth = changedMonth.substr(1, 1)
      // console.log(lowMonth)
      changeSelectedMonth(+lowMonth + 1)
      // changeSelectedMonth(lowMonth)
      setTimeout(() => changeSelectedMonth(lowMonth), 100)

    } else {
      // console.log(changedMonth)
      changeSelectedMonth(+changedMonth - 1)
      setTimeout(() => changeSelectedMonth(changedMonth), 100)
      // changeSelectedMonth(changedMonth)
    }

    setcurrentYear((+e.value.substr(0, 4)) + 0)
    setTimeout(() => setcurrentYear((+e.value.substr(0, 4) - 0)), 200)
  }

  function exitEdit() {
    setisEditing(false)
  }

  function handleDelete(e) {

    var answer = window.confirm("Are you sure you want to delete?");
    if (answer) {
        // console.log("do delete")
        deleteevent(idToEdit)
        // setTimeout(() => afterEffect(e), 500)
        afterEffect(e)
        clearInputs()
        setisEditing(false)
    }
    else {
        console.log("don't delete")
        return
    }



    // console.log(e)
    
  }

  function clearInputs() {
    // console.log('running clear inputs inside Edit event')
    setnameToEdit('')
    setdateToEdit("")
    setidToEdit("")
  }

  function handleEditNameChange(e) {
    let neweventName = e;
    // console.log(e)
    setnameToEdit(neweventName)
    // console.log(neweventName)
  }

  function handleEditDateChange(e) {
    // console.log(e)
    let neweventDate = e;
    setdateToEdit(neweventDate)
    // console.log(newUserevent)
  }

  // add isEditing to context but remove it to use as callback
  useEffect(() => {

    const exitModal = (event) => {
      // console.log(event.target.parentNode)
        const container = document.querySelector("#editEvent-container")
  
        if (container?.contains(event.target)) return 
  
      if (isEditing) {
        setisEditing(false)
      } else {
        console.log("it was already false")
      }
    };
  
    window.addEventListener('click', exitModal);
  
      return () => {
        // console.log("Cleaning up unmounting")
        window.removeEventListener('click', exitModal)
      };
  
  });

  return (
    <>
    <div id="editEvent-container">

    <button onClick={() => exitEdit()} className="back-button">{`Back`}</button>
  

    <div id="form">
    <input onChange={(e)=> handleEditDateChange((e.currentTarget.value))} className="editid-input" type="text" placeholder="Edit Name..." value={idToEdit} ></input>
    <input onChange={(e)=> handleEditNameChange((e.currentTarget.value))} className="editname-input" type="text" value={nameToEdit} ></input>
    <input onChange={(e)=> handleEditDateChange((e.currentTarget.value))} className="editdate-input" type="date" value={dateToEdit} ></input>
    <button onClick={(e) => handleClick(e.currentTarget.previousSibling)} className="editEvent-button">Edit info</button>
    <button onClick={(e) => handleDelete(e.currentTarget.previousSibling.previousSibling)} className="deleteEvent-button">Delete</button>
    </div>

    </div>
    </>
  );
};

export default EditEvent;